export default {
  title: "SE"
  , form: {
    se: {
      label: "SE"
      , th: "SE / SELLER / STOREID"
    }
    , seller: { label: "Seller" }
    , storeid: { label: "Store ID" }
    , negocio: {
      label: "Negocio"
      , th: "Negocio"
    }
    , nombre: { label: "Nombre" }
    , razonsocial: { label: "Razón Social" }
    , cuit: {
      label: "CUIT"
      , th: "CUIT"
    }
    , direccion: { label: "Dirección" }
    , altura: { label: "Altura" }
    , provincia: {
      label: "Provincia"
      , th: "Provincia"
    }
    , localidad: {
      label: "Localidad"
      , th: "Localidad"
    }
    , referencia: { label: "Referencia" }
    , codigopostal: { label: "Código Postal" }
    , email: { label: "Email" }
    , telefono: { label: "Teléfono" }
    , acuerdo: { label: "Acuerdo" }
    , subindustria: {
      label: "Sub Industria"
      , th: "Sub Industria"
    }
    , partner: {
      label: "Partner"
      , th: "Partner"
    }
    , latitud: { label: "Latitud" }
    , longitud: { label: "Longitud" }
    , grupocontrol: { label: "Grupo Control" }
    , geoRelevancia: { label: "Geo-Relevancia" }
  }
  , photos: "Galería de Imágenes"
  , filters: {
    se: "SE"
    , seller: "Seller"
    , storeid: "Store ID"
    , negocio: "Negocio"
    , cuit: "CUIT"
    , provincia: "Provincia"
    , localidad: "Localidad"
    , acuerdo: "Acuerdo"
    , subindustria: "Sub Industria"
    , partner: "Partner"
    , grupocontrol: "Grupo Control"
    , status: "Estatus"
  }
  , rules: {
    requerido: { text: "El valor es requerido" }
    , geoRelevancia: { text: "El valor debe de estar entre 0 y 1" }
  }
  , errors: {
    BD5014: { text: "Ocurrió un error en el catálogo de SE" }
    , WS5014: { text: "Ocurrió un error en el catálogo de SE" }
    , JS5014: { text: "Ocurrió un error en el catálogo de SE" }
    , CR5014: { text: "Ocurrió un error en el catálogo de SE" }
    , SC5014: { text: "El SE no se puede desactivar si esta asignado a campañas activas" }
    , UK_SE: { text: "Ya existe un registro con el mismo SE o Seller" }
  }
};



// WEBPACK FOOTER //
// ./src/locales/languages/es_MX/view/operativos/se.js